import { Controller } from '@hotwired/stimulus'

/* stimulusFetch: 'lazy' */
export default class extends Controller {

    static targets = [
        'bubble',
    ]

    toggle(event) {
        const bubble = event.currentTarget
        const isCurrentlySelected = bubble.classList.contains('confrere-tab-bubble--selected')

        bubble.classList.toggle('confrere-tab-bubble--selected')

        const selectedPostulationTypeIds = this.bubbleTargets
            .filter((b) => b.classList.contains('confrere-tab-bubble--selected'))
            .map((b) => Number(b.dataset.termId))

        fetch(routes['app_profile_postulationfieldupdate'], {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
                selectedPostulationTypeIds: selectedPostulationTypeIds,
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok')
                }

                addAlert('confrere-green', translations['profile.Changes saved!'])
            })
            .catch(() => {
                if (isCurrentlySelected) {
                    bubble.classList.add('confrere-tab-bubble--selected')
                } else {
                    bubble.classList.remove('confrere-tab-bubble--selected')
                }

                addAlert('danger', translations['profile.An unknown error occurred.'])
            })
    }
}
